import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Grid, Box, Modal, makeStyles } from "@material-ui/core";

import { RevenuesTotal } from "./RevenuesTotal";
import { Help } from "../../../../components/help";
import { RevenuesOverTime } from "./RevenuesOverTime";
import { currencyFormatter } from "../../../../services";
import { ConnectTenants } from "../../../../components/connectTenants";
import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Content = React.forwardRef((props, ref) => <ConnectTenants {...props} innerRef={ref} />);

export const OverviewTab = () => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const [toggleFilter, setToggleFilter] = useState(currencySymbol);
  const [isOpen, setOpen] = useState(false);
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  const helpRows = [
    {
      label: "Connect unconnected Tenants - Currently, only 34% of your Tenants are connected",
      value: `Est. revenue potential: ${currencyFormatter(45000, currencySymbol)}/Y`,
    },
    {
      label: "Add new power assets (5 recommendations)",
      value: `Est. revenue potential: ${currencyFormatter(45000, currencySymbol)}/Y`,
    },
    {
      label: "Incentivize Top Tenants (HOLD)",
    },
  ];

  useEffect(() => {
    helpRows[1].onClick = () => setOpen(true);
  }, []);

  return (
    <Box>
      <ActionTimeGroup
        showToggleFilter={true}
        toggleFilter={toggleFilter}
        setToggleFilter={setToggleFilter}
      />

      <Grid container spacing={4} alignItems="stretch">
        <Grid container item xs={12} sm={4} style={{ display: "flex" }}>
          <RevenuesTotal
            period={period}
            startDate={startDate}
            endDate={endDate}
            graphUnit={toggleFilter}
          />
        </Grid>
        <Grid item xs={12} sm={8} style={{ display: "flex" }}>
          <RevenuesOverTime
            period={period}
            startDate={startDate}
            endDate={endDate}
            graphUnit={toggleFilter}
          />
        </Grid>
      </Grid>

      <Box style={{ marginTop: 80 }}>
        <Help title="How To Increase My Power Revenues?" rows={helpRows} />
      </Box>

      <Modal className={classes.modal} open={isOpen} onClose={() => setOpen(false)}>
        <Content onClose={() => setOpen(false)} />
      </Modal>
    </Box>
  );
};
